import { Button } from "@/components/base/Button";
import { useNavigate } from "react-router-dom";
import { usePaginatedData } from "@/hooks/usePaginatedData";
import { customersColumns } from "@/components/datatables/customers/Customers.Columns";
import { customer } from "@/repositories/customer";
import { EyeIcon } from "lucide-react";
import { Customer } from "@/models";
import { DataTable } from "@/components/datatables/DataTable";
import { Input } from "@/components/base/Input";
import { Label } from "@/components/base/Label";
import { useDebounceCallback } from "@/hooks/useDebounceCallback";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/base/Tooltip";

export const CustomersTable = () => {
  const navigate = useNavigate();
  const {
    data,
    rowCount,
    pagination,
    setPagination,
    searchString,
    handleSearchStringUpdate,
    loading,
    sorting,
    setSorting,
  } = usePaginatedData(customer.search);

  const actions = (customer: Customer) => {
    return [
      <Button onClick={() => navigate(customer.id)} variant="secondary">
        <EyeIcon />
      </Button>,
    ];
  };

  const searchCustomers = async (searchString: string) => {
    handleSearchStringUpdate(searchString);
  };

  const debouncedSearch = useDebounceCallback(searchCustomers, 500);

  return (
    <div className="p-4 w-full flex flex-col gap-4">
      <div className="max-w-96 flex flex-col gap-2">
        <Label>Search Customers</Label>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <Input
                defaultValue={searchString}
                onChange={(e) => {
                  debouncedSearch(e.target.value);
                }}
              />
            </TooltipTrigger>
            <TooltipContent>
              <div>
                <p>You can search by:</p>
                <ul>
                  <li>First Name</li>
                  <li>Last Name</li>
                  <li>Email</li>
                </ul>
              </div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <DataTable
        loading={loading}
        data={data}
        columns={customersColumns({ actions: actions })}
        pagination={pagination}
        setPagination={setPagination}
        rowCount={rowCount}
        sorting={sorting}
        setSorting={setSorting}
      />
    </div>
  );
};
